/**
 * DONO DO DOM — Core Web Components & Utilities
 * Version: 1.0.0-DDC
 * Theme: Prestige Customization
 */

if (!customElements.get('ddc-element')) {
  class DdcElement extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Base lifecycle initialization
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }
  }

  customElements.define('ddc-element', DdcElement);
}
